document.addEventListener('DOMContentLoaded', () => {
  const SELECTORS = {
    page: '.page',
    headerContainer: '.header__top-block',
    headerMenu: '.header__menu',
    buttonMenu: '.header__button-menu',
    menuItemSubmenu: '.menu__item--submenu > .menu__link',
    menuItemSubmenuParent: '.menu__item--submenu'
  };

  const CLASSES = {
    iconMenu: 'icon-menu_24',
    iconClose: 'icon-close_24',
    headerOpenMenu: 'header__top-block--open-menu',
    menuShow: 'header__menu--show',
    pageFixed: 'page--fixed',
    submenuShow: 'menu__item--submenu-show',
    linkActive: 'menu__link--active'
  };

  const BREAKPOINT = 1326;
  const page = document.querySelector(SELECTORS.page);
  const headerContainer = document.querySelector(SELECTORS.headerContainer);
  const headerMenu = document.querySelector(SELECTORS.headerMenu);
  const buttonMenu = document.querySelector(SELECTORS.buttonMenu);
  const menuItemsSubmenu = document.querySelectorAll(SELECTORS.menuItemSubmenu);

  if (!headerMenu) return;

  const closeAllSubmenus = () => {
    document.querySelectorAll(`.${CLASSES.submenuShow}`).forEach(item => {
      item.classList.remove(CLASSES.submenuShow);
      const link = item.querySelector(SELECTORS.menuItemSubmenu);
      if (link) {
        link.classList.remove(CLASSES.linkActive);
      }
    });
  };

  const toggleSubmenu = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();

    const currentItem = evt.currentTarget.parentElement;
    const isOpenSubmenu = currentItem.classList.contains(CLASSES.submenuShow);

    closeAllSubmenus();

    if (!isOpenSubmenu) {
      currentItem.classList.add(CLASSES.submenuShow);
      evt.currentTarget.classList.add(CLASSES.linkActive);
    }
  };

  const toggleMenu = (evt) => {
    evt.preventDefault();
    const isMobile = window.innerWidth < BREAKPOINT;
    buttonMenu.classList.toggle(CLASSES.iconMenu);
    buttonMenu.classList.toggle(CLASSES.iconClose);
    headerContainer.classList.toggle(CLASSES.headerOpenMenu);
    headerMenu.classList.toggle(CLASSES.menuShow);

    if (isMobile) {
      page.classList.toggle(CLASSES.pageFixed);
    }
  };

  const addSubmenuEventListeners = () => {
    menuItemsSubmenu.forEach(item => {
      item.removeEventListener('click', toggleSubmenu);
      item.addEventListener('click', toggleSubmenu, { passive: false });
    });
  };

  const removeSubmenuEventListeners = () => {
    menuItemsSubmenu.forEach(item => {
      item.removeEventListener('click', toggleSubmenu);
    });
  };

  const resetMenuState = () => {
    page.classList.remove(CLASSES.pageFixed);
    buttonMenu.classList.add(CLASSES.iconMenu);
    buttonMenu.classList.remove(CLASSES.iconClose);
    headerContainer.classList.remove(CLASSES.headerOpenMenu);
    headerMenu.classList.remove(CLASSES.menuShow);

    closeAllSubmenus();
  };

  const resizeHandler = () => {
    const isMobile = window.innerWidth < BREAKPOINT;
    if (isMobile) {
      addSubmenuEventListeners();
    } else {
      removeSubmenuEventListeners();
    }

    resetMenuState();
  };

  const documentClickHandler = (evt) => {
    if (!evt.target.closest(SELECTORS.menuItemSubmenuParent)) {
      closeAllSubmenus();
    }
  };

  buttonMenu.addEventListener('click', toggleMenu);
  window.addEventListener('resize', resizeHandler);
  document.addEventListener('click', documentClickHandler);

  if (window.innerWidth < BREAKPOINT) {
    addSubmenuEventListeners();
  }
});
